import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { DashboardComponentsModule } from './dashboard-components/dashboard-components-module';
import { SessionStorageService } from '../../core/services/session-storage/session-storage.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SelectOptions } from '../../core/interfaces/select-options.interface';

@Component({
  selector: 'app-dashboard',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    MatCardModule,
    MatTabsModule,
    ReactiveFormsModule,

    DashboardComponentsModule
  ],
  standalone: true,
  templateUrl: './dashboard.page.html',
  styleUrl: './dashboard.page.scss'
})
export class DashboardPage implements OnInit {

  private sessionStorageService = inject(SessionStorageService);

  protected selectedTabId: string = "";
  protected currentUserRole: string = "";
  protected currentUserGroup: string = "";

  protected targetYearOptions: SelectOptions[] = [];
  protected targetYearFc = new FormControl();

  protected isAffinityUser = signal(false);


  protected currentYear: number = new Date().getFullYear();
  protected previousYear: number = this.currentYear - 1;

  constructor() { }

  ngOnInit(): void {
    this.selectedTabId = "incepted-ape";

    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.currentUserGroup = this.sessionStorageService.getCurrentUserGroup();

    // Generating Target Year Options
    this.targetYearOptions.push({
      name: this.previousYear.toString(),
      value: this.previousYear.toString()
    });

    this.targetYearOptions.push({
      name: this.currentYear.toString(),
      value: this.currentYear.toString()
    });

    // Setting default target year.
    if (new Date().getMonth() == 0) {
      this.targetYearFc.setValue(this.previousYear.toString());
    } else {


      this.targetYearFc.setValue(this.currentYear);
    }

    if (['Affinity'].includes(this.currentUserGroup)) {
      this.isAffinityUser.set(true);
    }
  }

  protected __onDashboardTabChange(event: MatTabChangeEvent) {
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    } else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

}
